import { Box, Grid, SxProps } from '@mui/material';
import React from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
const styles: IStyles = {
  root: {
    // boxShadow: '0px 0px 11px rgba(0, 0, 0, 0.1)',
    paddingX: {
      xs: 0,
      md: 0,
    },
  },
};
interface IProps {
  items: React.ReactNode[];
  WebNoOfCols: number;
  mobileNoOfCols: number;
  rootStyle?: SxProps;
  hiddenBorderBottom?: boolean;
}
export const DashboardGrid = (props: IProps) => {
  const {
    items = [],
    WebNoOfCols,
    mobileNoOfCols,
    rootStyle,
    hiddenBorderBottom,
  } = props;

  // if (!items || items.length === 0) {
  //   return <Box>No items to display</Box>;
  // }
  let rootSx = { ...styles.root };
  if (rootStyle) rootSx = { ...rootSx, ...rootStyle };

  return (
    <Grid
      container
      rowSpacing={{ xs: 0, md: 3 }}
      columnSpacing={{ xs: 1.5, md: 2 }}
      sx={rootSx}
    >
      {items.map((item, index) => {
        const isFirst = index === 0;
        const isLast = index === items.length - 1;
        return (
          <Grid
            item
            xs={12 / mobileNoOfCols}
            md={12 / WebNoOfCols}
            key={`dashboard_item_${index}`}
          >
            <Box
              sx={{
                boxShadow: {
                  xs: 'none',
                  md: '0px 0px 11px #E7E7E7D9',
                },
                borderRadius: {
                  xs: 0,
                  md: '15px',
                },
                borderTop: {
                  xs: isFirst ? '1px solid #DADADA' : 'none',
                  md: 'none',
                },
                borderCollapse: 'collapse',
                borderBottom: {
                  xs: '1px solid #DADADA',
                  md: 'none',
                },
                paddingX: {
                  xs: '10px',
                  md: 0,
                },
                background: '#FFFFFF',

                // marginTop: {
                //   md: pxTovW(20),
                //   xs: pxToRem(10),
                // },
                // marginBottom: {
                //   md: pxTovW(20),
                //   xs: pxToRem(10),
                // },
              }}
            >
              {item}
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};
